/* CRST skin for the Pop Convert popup (app embed `pop-convert`).
   The widget renders inside an OPEN shadow root on #pop-convert-app, so page CSS
   can't cascade in; we append one <style> into the shadow root instead. Campaign
   colors arrive as inline styles / hashed CSS vars from the app admin, hence the
   !important on overridden properties. Selectors use the app's stable semantic
   class names (.modal-card, .form-block-input, .submit-button, …) — if an app
   update ever renames those, the popup falls back to its admin-configured look
   (never breaks). Copy/images stay managed in the Pop Convert admin. */
(function () {
  var CSS = [
    '.fullscreen{background-color:rgba(4,4,5,.72)!important}',
    '.modal-card{background:#131316!important;border:1px solid #34343C;border-radius:10px!important;overflow:hidden}',
    '.modal-content,.pop-content-blocks,.blocks-renderer{background:#131316!important;background-color:#131316!important;color:#F4F4F2;font-family:Barlow,sans-serif}',
    '.pop-content-blocks .blocks-renderer .block.text-block h1,.pop-content-blocks .blocks-renderer .block.text-block h2,.pop-content-blocks .blocks-renderer .block.text-block h3{font-family:Archivo,sans-serif!important;font-weight:800!important;color:#fff!important;text-transform:uppercase!important;letter-spacing:-.01em!important;line-height:1.12!important}',
    '.text-block p{font-family:Barlow,sans-serif!important;color:#9B9BA8!important}',
    '.form-block-input{background-color:#1B1B1F!important;color:#F4F4F2!important;border:1px solid #34343C!important;border-radius:6px!important;font-family:Barlow,sans-serif!important}',
    '.form-block-input::placeholder{color:#7C7C88!important}',
    '.form-block-input:focus{border-color:#FFD400!important;outline:none!important}',
    '.input-wrapper svg{color:#9B9BA8!important}',
    '.submit-button{background:#FFD400!important;background-color:#FFD400!important;color:#0A0A0B!important;font-family:Barlow,sans-serif!important;font-weight:700!important;text-transform:uppercase;letter-spacing:.05em;border-radius:6px!important;border:0!important;transition:background .15s ease}',
    '.submit-button:hover{background:#FFE34D!important;background-color:#FFE34D!important}',
    '.divider-block,.divider-block hr{border-color:#34343C!important;opacity:1}',
    '.social-networks-block svg,.social-network-block-wrapper svg{color:#9B9BA8!important}',
    '.social-network-block-wrapper:hover svg{color:#FFD400!important}',
    /* The floating trigger bubble is redundant now that the announcement bar and the
       PDP promo row open the popup — hide it visually but KEEP it in the DOM: its
       .pc-button is the programmatic handle crstOpenSignup() clicks. Do not remove
       the trigger widget in the Pop Convert admin. */
    '.pc-buttons-trigger-wrapper{display:none!important}'
  ].join('\n');

  function arm() {
    var host = document.getElementById('pop-convert-app');
    if (!host || !host.shadowRoot) return false;
    if (!host.shadowRoot.getElementById('crst-popconvert-skin')) {
      var st = document.createElement('style');
      st.id = 'crst-popconvert-skin';
      st.textContent = CSS;
      host.shadowRoot.appendChild(st);
    }
    return true;
  }

  if (!arm()) {
    var tries = 0;
    var iv = setInterval(function () {
      if (arm() || ++tries > 60) clearInterval(iv);
    }, 500);
  }

  /* NOTE: the signup-modal openers for [data-crst-signup] and a[href="#signup"] now
     live in snippets/crst-signup-modal.liquid, so those triggers survive Pop Convert
     being uninstalled. This file is now ONLY the Pop Convert skin — it can be removed
     entirely when Pop Convert is decommissioned without breaking the signup modal.
     Back-compat: keep window.crstOpenSignup pointing at the modal opener. */
  window.crstOpenSignup = function () { if (window.crstSignupOpen) window.crstSignupOpen(); };
})();
